import { useContext, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import ProcessSearchContext from '../context/process-search-context';
import { addProcessClaim, removeProcessClaim } from '../store/actions/process';
import { processListSelector } from '../store/selectors/process';
function useProcessList(processType) {
    var dispatch = useDispatch();
    var psContext = useContext(ProcessSearchContext);
    var processList = useSelector(processListSelector(processType, psContext.name), shallowEqual);
    useEffect(function () {
        if (processType && processList && processList.length > 0) {
            dispatch(addProcessClaim({
                ids: processList.map(function (process) { return process.id; }),
                processName: processType,
            }));
        }
        return function () {
            if (processType && processList && processList.length > 0) {
                dispatch(removeProcessClaim({
                    ids: processList.map(function (process) { return process.id; }),
                    processName: processType,
                }));
            }
        };
    }, [processType, processList]);
    return processList;
}
export default useProcessList;
//# sourceMappingURL=useProcessList.js.map